export const TABLE_COLUMNS = [
  { label: "Username", queryKey: "Username" },
  { label: "Email", queryKey: "email" },
  { label: "role", queryKey: "role" },
  { label: "Access" },
  { label: "" },
];

export const entityName = "members-table";
